export enum ViewStateType {
  CALENDAR_STARTING_DATE = "CALENDAR_STARTING_DATE",
  CALENDAR_SHIFT_FILTER_FACILITIES = "CALENDAR_SHIFT_FILTER_FACILITIES",
  CALENDAR_SHIFT_FILTER_PROVIDERS = "CALENDAR_SHIFT_FILTER_PROVIDERS",
  CALENDAR_SHIFT_FILTER_SPECIALTIES = "CALENDAR_SHIFT_FILTER_SPECIALTIES",
  CALENDAR_SHIFT_FILTER_STATES = "CALENDAR_SHIFT_FILTER_STATES",
  CALENDAR_SHIFT_FILTER_SHIFTS = "CALENDAR_SHIFT_FILTER_SHIFTS",
  CALENDAR_SHIFT_FILTER_PROVIDER_OWNERS = "CALENDAR_SHIFT_FILTER_PROVIDER_OWNERS",
  CALENDAR_SHIFT_FILTER_FACILITY_OWNERS = "CALENDAR_SHIFT_FILTER_FACILITY_OWNERS",
  CALENDAR_SHIFT_FILTER_LOGISTICS = "CALENDAR_SHIFT_FILTER_LOGISTICS",
  PROVIDER_SEARCH_SIMPLE = "PROVIDER_SEARCH_SIMPLE",
  PROVIDER_CONTACT_SEARCH_SIMPLE = "PROVIDER_CONTACT_SEARCH_SIMPLE",
  PROVIDER_SEARCH_ADVANCED = "PROVIDER_SEARCH_ADVANCED",
  PROVIDER_CONTACT_SEARCH_ADVANCED = "PROVIDER_CONTACT_SEARCH_ADVANCED",
  FACILITY_SEARCH_SIMPLE = "FACILITY_SEARCH_SIMPLE",
  FACILITY_SEARCH_ADVANCED = "FACILITY_SEARCH_ADVANCED",
  TASK_SEARCH_ADVANCED = "TASK_SEARCH_ADVANCED",
  TODAY_TASKS_STATE = "TODAY_TASK_STATE",
  WEEK_TASKS_STATE = "WEEK_TASK_STATE",
  INCOMING_TASKS_STATE = "INCOMING_TASK_STATE",
  INCOMING_TASKS_TAB_STATE = "INCOMING_TASKS_TAB_STATE",
  RIGHT_PANEL_TASKS = "RIGHT_PANEL_TASKS",
  LATER_TASKS_STATE = "LATER_TASK_STATE",
  WAITING_TASKS_STATE = "WAITING_TASKS_STATE",
  COMPLETED_TASKS_STATE = "COMPLETED_TASKS_STATE",
  DELEGATED_TASKS_STATE = "DELEGATED_TASKS_STATE",
  SELECTED_CAMPAIGN_CONTACTS = "SELECTED_CAMPAIGN_CONTACTS",
  COMMUNICATION_SEARCH = "COMMUNICATION_SEARCH",
  COMMUNICATION_GROUP_SEARCH = "COMMUNICATION_GROUP_SEARCH",
  COMMUNICATION_SELECTED_CAMPAIGN = "COMMUNICATION_SELECTED_CAMPAIGN",
  COMMUNICATION_SELECTED_RECEIVER = "COMMUNICATION_SELECTED_RECEIVER",
  COMMUNICATION_SELECTED_MESSAGE_TYPE = "COMMUNICATION_SELECTED_MESSAGE_TYPE",
  COMMUNICATION_SELECTED_FILTERS = "COMMUNICATION_SELECTED_FILTERS",
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/ViewStateType.ts